"use client";

import { useEffect, useRef, useState } from "react";

const stats = [
  { value: 18, suffix: "+", label: "Years of Passion", description: "Serving cyclists since 2008" },
  { value: 6400, suffix: "+", label: "Bikes Sold", description: "Happy riders across 38 states" },
  { value: 120, suffix: "+", label: "Models In-Stock", description: "Road, MTB, electric & more" },
  { value: 98, suffix: "%", label: "Satisfaction Rate", description: "Verified purchase reviews" },
];

function useCountUp(target: number, active: boolean) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!active) return;
    let start = 0;
    const duration = 1800;
    const step = target / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [target, active]);
  return count;
}

function StatItem({ value, suffix, label, description, active, delay }: {
  value: number; suffix: string; label: string; description: string; active: boolean; delay: number;
}) {
  const count = useCountUp(value, active);
  return (
    <div
      className={`reveal text-center md:text-left ${delay === 1 ? "reveal-delay-1" : delay === 2 ? "reveal-delay-2" : delay === 3 ? "reveal-delay-3" : "reveal-delay-4"}`}
    >
      <p className="stat-number text-5xl md:text-6xl font-black text-charcoal mb-1">
        {count.toLocaleString()}{suffix}
      </p>
      <p className="font-semibold text-charcoal text-sm uppercase tracking-widest mb-1">{label}</p>
      <p className="text-stone-warm text-sm">{description}</p>
    </div>
  );
}

export default function StatsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setActive(true); },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="story"
      ref={sectionRef}
      className="py-20 border-y border-stone-border bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-16">
        {stats.map((s, i) => (
          <StatItem key={s.label} {...s} active={active} delay={i + 1} />
        ))}
      </div>
    </section>
  );
}